var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNetworkError = function SvgNetworkError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127,
    height: 127,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D6DEE1",
    d: "M60.5 33.065v-.022c0-5.232-4.23-9.471-9.448-9.471a9.4 9.4 0 0 0-5.758 1.963C43.793 20.04 38.776 16 32.817 16h-.859c-6.466 0-11.823 4.756-12.783 10.968C12.893 27.642 8 32.972 8 39.448 8 46.381 13.606 52 20.52 52h25.193v-.039h13.84c5.218 0 9.447-4.24 9.447-9.47 0-4.911-3.727-8.95-8.501-9.426zM70.943 85.117v-.02c0-4.942 3.952-8.946 8.828-8.946 2.025 0 3.892.692 5.38 1.855C86.555 72.815 91.243 69 96.812 69h.802c6.042 0 11.048 4.492 11.945 10.36 5.87.635 10.442 5.668 10.442 11.786 0 6.547-5.238 11.854-11.699 11.854H84.76v-.036H71.828c-4.876 0-8.828-4.006-8.828-8.946 0-4.637 3.483-8.45 7.944-8.901z",
    opacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#888EA0",
    fillRule: "evenodd",
    d: "M64.503 35c14.786 0 28.686 5.716 39.136 16.094h-.004a4.61 4.61 0 0 1 0 6.55c-1.823 1.806-4.778 1.81-6.598 0-8.689-8.63-20.244-13.381-32.534-13.381s-23.848 4.751-32.538 13.38A4.66 4.66 0 0 1 28.668 59a4.68 4.68 0 0 1-3.3-1.355 4.605 4.605 0 0 1 0-6.55C35.822 40.716 49.718 35 64.503 35m-.501 15c-10.812 0-20.974 4.226-28.62 11.9a4.76 4.76 0 0 0 0 6.71 4.71 4.71 0 0 0 6.685 0c5.857-5.883 13.648-9.121 21.935-9.121s16.074 3.238 21.931 9.12a4.722 4.722 0 0 0 6.684 0 4.76 4.76 0 0 0 0-6.709C84.973 54.226 74.815 50 64.003 50M47.349 73.124A24.05 24.05 0 0 1 64.496 66h.008c6.474 0 12.568 2.53 17.147 7.124a4.62 4.62 0 0 1 0 6.524 4.58 4.58 0 0 1-3.252 1.35 4.6 4.6 0 0 1-3.256-1.35A14.92 14.92 0 0 0 64.5 75.227a14.93 14.93 0 0 0-10.643 4.42 4.59 4.59 0 0 1-6.508 0 4.62 4.62 0 0 1 0-6.523m10.993 22.68c-3.123-2.927-3.123-7.68 0-10.608s8.19-2.928 11.316 0c3.123 2.927 3.123 7.677 0 10.608-3.123 2.928-8.19 2.928-11.316 0",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DAE1E4",
    d: "M100.427 26.613a.654.654 0 0 1 0-1.226l1.878-.695a.66.66 0 0 0 .387-.387l.695-1.878a.654.654 0 0 1 1.226 0l.695 1.878c.067.18.208.32.387.387l1.878.695a.654.654 0 0 1 0 1.226l-1.878.696a.66.66 0 0 0-.387.386l-.695 1.878a.654.654 0 0 1-1.226 0l-.695-1.878a.66.66 0 0 0-.387-.386zM110.034 35.354l.901.84a.567.567 0 0 1 0 .842l-.901.84a.67.67 0 0 1-.9 0l-.901-.84a.57.57 0 0 1 0-.841l.901-.841a.67.67 0 0 1 .9 0M92.035 22.354l.9.84a.567.567 0 0 1 0 .842l-.9.84a.67.67 0 0 1-.901 0l-.9-.84a.567.567 0 0 1 0-.841l.9-.841a.67.67 0 0 1 .9 0M27.427 85.613a.654.654 0 0 1 0-1.226l1.878-.695a.65.65 0 0 0 .387-.386l.695-1.88a.654.654 0 0 1 1.226 0l.695 1.88c.067.178.208.32.386.386l1.88.695a.654.654 0 0 1 0 1.226l-1.88.696a.65.65 0 0 0-.386.386l-.695 1.878a.654.654 0 0 1-1.226 0l-.695-1.878a.65.65 0 0 0-.387-.386zM33.251 97.42l.9.841a.567.567 0 0 1 0 .841l-.9.841a.67.67 0 0 1-.9 0l-.9-.84a.567.567 0 0 1 0-.842l.9-.841a.67.67 0 0 1 .9 0M17.65 80.495l1.06.99a.67.67 0 0 1 0 .99l-1.06.99a.79.79 0 0 1-1.06 0l-1.06-.99a.67.67 0 0 1 0-.99l1.06-.99a.787.787 0 0 1 1.06 0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#network-error_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D50000",
    d: "M96.02 90.27a14.32 14.32 0 1 1 10.96 26.46 14.32 14.32 0 0 1-10.96-26.46"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.708,
    d: "M102.506 111.146a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 4,
    d: "M101.707 97.093v9.094"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "network-error_svg__a",
    width: 34.64,
    height: 34.641,
    x: 84.18,
    y: 85.18,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1637_5922"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_1637_5922",
    result: "effect2_dropShadow_1637_5922"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1637_5922",
    result: "shape"
  })))));
};
export default SvgNetworkError;